import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { GET_CART, PLACE_ORDER } from '../queries/cart';

const usePlaceOrder = () => {
  const [mutation, { loading, called, error, data }] = useMutation(PLACE_ORDER, {
    refetchQueries: [{ query: GET_CART }],
  });

  const placeOrder = useCallback(
    input => {
      let { additionalData } = input || {};
      if (!additionalData) {
        additionalData = null;
      }
      return mutation({
        variables: {
          input: { additionalData },
        },
      });
    },
    [mutation],
  );

  return {
    placeOrder,
    loading,
    called,
    error,
    data,
  };
};

export default usePlaceOrder;
